import MobileNav from '@/components/MobileNav';
import { useTranslations } from '@/i18n/use-translations';

interface ContactBannerProps {
  className?: string;
  isMobile?: boolean;
}

export default function ContactBanner({ className = '', isMobile }: ContactBannerProps) {
  const t = useTranslations('contact-zeelool.banner');
  return (
    <div className={`${className}`}>
      {isMobile && (
        <>
          <MobileNav
            className="sticky z-11 top-0 left-0 w-full bg-white"
            titleClassName="text-center w-full text-[18px] font-bold"
            title={t('mobileTitle')}
          />
          <div
            className="pt-[40px] w-screen h-[190px] bg-[#463ae8] bg-[url('/zeelool-next/contact-zeelool/banner-bg-mobile.png')]"
            style={{
              backgroundPosition: 'center center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100vw 190px',
            }}
          >
            <div className="relative z-10 text-center text-white">
              <p className="text-center block px-[30px] mt-3 text-[13px] font-br text-white leading-[18px]">
                {t('description')}
                <br />
                {t('description2')}
              </p>
            </div>
          </div>
        </>
      )}

      {!isMobile && (
        <div
          className="relative w-full h-[210px] bg-[#463ae8] bg-[url('/zeelool-next/contact-zeelool/banner-bg.png')]"
          style={{
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
        >
          <div className="relative z-10 pt-[58px] text-center text-white">
            <h1 className="text-[40px] font-bb text-white leading-40 text-center block">
              {t('title')}
            </h1>
            <div className="mt-[14px]">
              <p className="text-base font-br text-white leading-20 text-center block">
                {t('description')}
                <br />
                {t('description2')}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
